import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';;
import { DomSanitizer } from '@angular/platform-browser';
import { CategoryType } from '@core/models/category-type.model';
import { ContractCgrpOff } from '@core/models/contract-cgrp-off.model';
import { ContractItem } from '@core/models/contract-item.model';
import { Contract } from '@core/models/contract.model';
import { FilteredItem } from '@core/models/filtered-item.model';
import { NegotiationType } from '@core/models/negotiation-type.model';
import { FilteredTarget, Target } from '@core/models/target.model';
import { CategoryTypeService } from '@core/services/category-type/category-type.service';
import { ContractCategoryTypeService } from '@core/services/contract-category-type/contract-category-type.service';
import { ContractCgrpOffService } from '@core/services/contract-cgrp-off/contract-cgrp-off.service';
import { ContractCgvModelUpdateService } from '@core/services/contract-cgv-model-update/contract-cgv-model-update.service';
import { TargetService } from '@core/services/target.service';
import { Observable, Subject } from 'rxjs';
import { debounceTime, map, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-cgrp-off-managing-dialog',
  templateUrl: './cgrp-off-managing-dialog.component.html',
  styleUrls: ['./cgrp-off-managing-dialog.component.scss'],
  standalone: false,
})
export class CGRPOffManagingDialog implements OnInit {
  noCategoryBlockAdded: boolean = true;
  categoryConditionType: string = null;
  categories = [
    { value: 'Product', viewValue: 'Produit (Pr)' },
    { value: 'Advertiser', viewValue: 'Annonceur (An)' },
    { value: 'Specific', viewValue: 'Specific (Sp)' },
  ];
  @Input() cgrpOffData: any;
  public filteredItemList: Observable<any[]>;
  public filteredOptions: Observable<any[]>;
  public itemList: any[] = [];
  itemsFilterForm: FormGroup;
  targetControl = new FormControl(null, [Validators.required]);
  budgetControl = new FormControl(null, [Validators.required]);
  categoryTypeFormControl = new FormControl(null);
  searchFormControl = new FormControl(null);
  optionFormControl = new FormControl(null);
  filter = [];
  isCategoryTypeLoading: boolean = false;
  isTargetLoading: boolean = true;
  isTargetLoaded: boolean = false;
  isItemLoading: boolean = false;
  categoryTypeList: CategoryType[];
  targetList: Target[];
  filteredTargetList: Observable<Target[]>;
  componentDestroyed$: Subject<void> = new Subject();
  advertiserId = null;
  contractYear = null;
  public choosenItemList: any[] = [];
  public editStartDate = '';
  public editEndDate = '';
  public isEditing = false;
  public idDuplicating = false;
  public isShowOption = false;
  public selectedOptions: Set<any> = new Set();
  public selectAllOptions = false;
  public saving = false;
  public categoryType = null;

  constructor(
    private iconRegistry: MatIconRegistry,
    private fb: FormBuilder,
    private targetService: TargetService,
    private categoryTypeService: CategoryTypeService,
    private contractCategoryTypeService: ContractCategoryTypeService,
    private contractCgrpOffService: ContractCgrpOffService,
    private contractCgvModelUpdateService: ContractCgvModelUpdateService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<CGRPOffManagingDialog>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      contract: Contract;
      contractItem: ContractItem;
      cgrpOffData: ContractCgrpOff;
      action: string;
    }
  ) {
    iconRegistry.addSvgIcon('add-circle-fill', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/add-circle-fill.svg'));
    iconRegistry.addSvgIcon('delete-circle-fill', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/delete-circle-fill.svg'));
  }

  ngOnInit(): void {
    this.itemsFilterForm = this.fb.group({
      startDate: [null, [Validators.required]],
      endDate: [null, [Validators.required]],
      search: [null, []],
    });

    this.getTargetList('');
    this.getCategoryTypeList();

    this.handleCategoryTypeValueChange();
    this.handleItemValueChange();

    this.targetControl.valueChanges.pipe(takeUntil(this.componentDestroyed$), debounceTime(1000)).subscribe(value => {
      console.log('getTargetList', value);
    });

    if (this.data) {
      this.advertiserId = this.data.contract.advertiserId;
      this.contractYear = this.data.contract.stateContractYear;

      this.initFormData();
    }
  }

  private initFormData() {
    if (this.data.cgrpOffData) {
      if (this.data.action == 'edit') {
        this.idDuplicating = true;
      } else {
        this.isEditing = true;
      }

      this.budgetControl.setValue(this.data.cgrpOffData.value);

      // pre select for date
      // const from = moment(this.data.cgrpOffData.startDate, 'DD/MM/YYYY');
      // const to = moment(this.data.cgrpOffData.endDate, 'DD/MM/YYYY');
      this.editStartDate = this.data.cgrpOffData.startDate;
      this.editEndDate = this.data.cgrpOffData.endDate;

      if (this.data.cgrpOffData.conditions.length > 0) {
        if (this.data.cgrpOffData.conditions[0].isInclude) {
          this.addCategoryBloc('Inclus');
        } else {
          this.addCategoryBloc('Exclut');
        }

        // this.selectedOptions = new Set(this.data.cgrpOffData.conditions);
        this.selectedOptions = new Set();
        let conditions = this.data.cgrpOffData.conditions;
        for (let i = 0; i < conditions.length; i++) {
          this.selectedOptions.add(conditions[i]);
        }
      }
    } else {
      this.editStartDate = `01/01/${this.data.contract.cgvContractYear}`;
      this.editEndDate = `31/12/${this.data.contract.cgvContractYear}`;
    }
  }

  private handleItemValueChange() {
    this.searchFormControl.valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(value => {
      if (typeof value !== 'string' && value) {
        if (!this.isOptionSelected(value)) {
          this.selectedOptions.add({
            categoryType: this.categoryTypeFormControl.value,
            isInclude: this.categoryConditionType == 'Inclus' ? 1 : 0,
            category: value,
          });
        }

        this.searchFormControl.setValue('');
      }
    });
  }

  removeItem(chip: string): void {
    const index = this.choosenItemList.indexOf(chip);
    if (index >= 0) {
      this.choosenItemList.splice(index, 1);
    }
  }

  public getFormValues() {
    return {
      // isInclude: this.conditionType,
      // categoryType: this.categoryTypeFormControl.value,
      choosenItemList: this.choosenItemList,
    };
  }

  private getTargetList(name) {
    this.isTargetLoading = true;
    const filter = {
      name: name,
    };

    this.targetService
      .getList(filter)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        targetList => {
          this.isTargetLoading = false;
          this.isTargetLoaded = true;
          this.targetList = targetList;
          if (this.data.cgrpOffData) {
            const preselectedItem = this.targetList.find(item => item.id === this.data.cgrpOffData.targetCode);
            if (preselectedItem) {
              this.targetControl.setValue(preselectedItem);
            }
          }
          this.initFilteredTargetList();
        },
        error => {
          this.isTargetLoading = false;
          this.isTargetLoaded = true;
        }
      );
  }

  private initFilteredTargetList() {
    if (!this.isTargetLoading) {
      this.filteredTargetList = this.targetControl.valueChanges.pipe(
        takeUntil(this.componentDestroyed$),
        startWith(''),
        map(value => {
          return this._getLabel(value);
        }),
        map(label => {
          return label ? this._filter(label) : this.targetList.slice();
        })
      );
    }
  }

  private _getLabel(value: string | Target): string {
    return typeof value === 'string' ? value : value?.name || '';
  }

  /***
   * Fonction pour afficher le label dans l'input lors de la sélection
   * @param value
   * @private
   */
  private _filter(value: string = ''): Target[] {
    const filterValue = value.toLowerCase();
    return this.targetList.filter(target => {
      return target.id.toLowerCase().includes(filterValue) || target.name.toLowerCase().includes(filterValue);
    });
  }

  public displayTarget(negotiationType: FilteredTarget): string {
    return negotiationType?.name && negotiationType?.id ? `${negotiationType.name} (${negotiationType.id})` : '';
  }

  private getCategoryTypeList() {
    this.isCategoryTypeLoading = true;

    this.categoryTypeService
      .getCategoryTypeList({
        case: 'cgrp_off',
      })
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        categoryType => {
          this.categoryTypeList = categoryType;
          this.isCategoryTypeLoading = false;

          if (this.categoryTypeList.length > 0 && this.data.cgrpOffData && this.data.cgrpOffData.conditions.length > 0) {
            const preselectedItem = this.categoryTypeList.find(item => item.id === this.data.cgrpOffData.conditions[0].categoryType.id);
            if (preselectedItem) {
              this.categoryTypeFormControl.setValue(preselectedItem);
            }
          }
        },
        error => {
          this.isCategoryTypeLoading = false;
        }
      );
  }

  private handleCategoryTypeValueChange() {
    this.categoryTypeFormControl.valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(value => {
      this.categoryType = value;
      this.getCategoryItemList();
      this.searchFormControl.valueChanges.pipe(takeUntil(this.componentDestroyed$), debounceTime(1000)).subscribe(value => {
        this.getCategoryItemList();
      });
    });
  }

  private getParamsByCategoryType(categoryType) {
    switch (categoryType.id) {
      case 1: // Advertiser
      case 4: // Product
        return { advertiserGroupId: this.advertiserId };
      case 6: // Campaign
        return { advertiserGroupId: this.advertiserId, year: this.contractYear };
      case 3: // Secodip
        return { year: this.contractYear };
      case 2: // Mandatory / Agency
      case 5: // Product Type
      case 7: // Target
      case 8: // Channel
      case 9: // Screen Type
      case 10: // Screen
      case 11: // Time Slot
      default:
        return {};
    }
  }

  private getCategoryItemList() {
    let params = this.getParamsByCategoryType(this.categoryType);
    params = Object.assign(params, {
      name: this.searchFormControl.value ? this.searchFormControl.value : '',
    });

    this.isItemLoading = true;
    this.searchFormControl.disable({ emitEvent: false });

    this.contractCategoryTypeService
      .getItemList(params, this.categoryType)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        items => {
          this.isItemLoading = false;
          this.searchFormControl.enable({ emitEvent: false });
          this.itemList = items;
          // this.searchFormControl.enable();
          this.itemList = items;
          /* if (this.data.cgrpOffData && this.data.cgrpOffData.conditions.length > 0) {
            const preselectedItem = this.itemList.find(item => item.id === this.data.cgrpOffData.conditions[0].idCategoryValue);
            if (preselectedItem) {
              this.searchFormControl.setValue(preselectedItem);
            }
          } */
          this.initFilteredItemList();
          this.initFilteredOptions();
        },
        error => {
          this.isItemLoading = false;
          // this.searchFormControl.enable();
          this.searchFormControl.enable({ emitEvent: false });
        }
      );
  }

  private initFilteredItemList() {
    if (!this.isItemLoading) {
      this.filteredItemList = this.searchFormControl.valueChanges.pipe(
        takeUntil(this.componentDestroyed$),
        startWith(''),
        map(value => this._getItemLabel(value)),
        map(label => (label ? this._itemFilter(label) : this.itemList.slice()))
      );
    }
  }

  private initFilteredOptions() {
    if (!this.isItemLoading) {
      this.filteredOptions = this.optionFormControl.valueChanges.pipe(
        takeUntil(this.componentDestroyed$),
        startWith(''),
        map(value => this._getItemLabel(value)),
        map(label => (label ? this._itemFilter(label) : this.itemList.slice()))
      );
    }
  }

  /**
   * @param value
   * @private
   */
  private _getItemLabel(value: string | NegotiationType): string {
    return typeof value === 'string' ? value : value?.name || '';
  }

  /***
   * @param value
   * @private
   */
  private _itemFilter(value: string = ''): any[] {
    const filterValue = value.toLowerCase();
    return this.itemList.filter(item => item.id?.toString().includes(filterValue) || item.name?.toLowerCase().includes(filterValue));
  }

  public displayItem(item: FilteredItem): string {
    return item?.name && item?.id ? `${item.name} (${item.id})` : '';
  }

  public addCategoryBloc(conditionType: string): void {
    this.noCategoryBlockAdded = false;
    this.categoryConditionType = conditionType;
  }

  public listAllOptions(): void {
    this.searchFormControl.setValue('', { emitEvent: false });
    this.getCategoryItemList();
    this.isShowOption = true;
  }

  onValidationButtonClick() {
    if (this.targetControl?.valid && this.itemsFilterForm?.valid && this.budgetControl?.valid) {
      let conditions = [];

      if (this.selectedOptions.size > 0) {
        for (const option of this.selectedOptions) {
          conditions.push(option);
        }
      }

      let id;
      if (this.data.action !== 'dup') {
        id = this.data?.cgrpOffData?.id ? this.data.cgrpOffData.id : null;
      }

      let data = {
        id: id,
        contractItemId: this.data.contractItem?.id || null,
        targetCode: this.targetControl && this.targetControl.value ? this.targetControl.value.id : '',
        startDate: this.itemsFilterForm.get('startDate').value,
        endDate: this.itemsFilterForm.get('endDate').value,
        value: this.budgetControl.value,
        clientId: this.data.contract.id,
        stateContractYear: this.data.contract.stateContractYear,
        conditions: conditions,
      };

      this.saving = true;

      this.contractCgrpOffService.saveItem(data).subscribe(
        rs => {
          this.updateContractCgvModel();
        },
        error => {
          let msg = 'La validation a été échouée';
          if (error && error['error'] && error['error']['data'] && error['error']['data']['msg']) {
            msg = error['error']['data']['msg'];
          }
          this.snackBar.open(msg, null, {
            duration: 4000,
            verticalPosition: 'top',
            panelClass: ['tv-chip-error'],
          });
          this.saving = false;
        }
      );
    } else {
      this.displaySnackBar('Veuillez remplir ou corriger le formulaire.', 'tv-chip-error');
    }
  }

  public displaySnackBar(message: string, panelClass: string) {
    this.snackBar.open(message, null, {
      duration: 4000,
      verticalPosition: 'top',
      panelClass: [panelClass],
    });
  }

  private updateContractCgvModel() {
    this.contractCgvModelUpdateService.updateContractCgvModel(this.data.contractItem.id, this.data.contractItem).subscribe(
      response => {
        this.saving = false;
        this.displaySnackBar('Enregistrement terminé.', 'tv-chip-success');

        this.dialogRef.close({
          action: 'reload',
        });
      },
      error => {
        this.displaySnackBar("Erreur lors de la sauvegarde dans l'ancien modèle. Veuillez contacter le support.", 'tv-chip-error');
        this.saving = false;
      }
    );
  }

  onCancelUpdateButtonClick() {
    this.dialogRef.close({
      action: 'cancel',
    });
  }

  okDeleteButtonClick() {
    this.dialogRef.close({
      action: 'delete',
    });
  }

  goBack() {
    this.isShowOption = false;
  }

  saveOptions() {
    this.isShowOption = false;
  }

  onOptionChange(event: any, item: any) {
    if (event.checked) {
      if (!this.isOptionSelected(item)) {
        // this.selectedOptions.add(item);
        this.selectedOptions.add({
          categoryType: this.categoryTypeFormControl.value,
          isInclude: this.categoryConditionType == 'Inclus' ? 1 : 0,
          category: item,
        });
      }
    } else {
      // this.selectedOptions.delete(item);
      for (const option of this.selectedOptions) {
        if (option.category.id == item.id) {
          this.selectedOptions.delete(option);
          break;
        }
      }
    }
  }

  isOptionSelected(item) {
    for (const option of this.selectedOptions) {
      if (option.category.id == item.id) {
        return true;
      }
    }
    return false;
  }

  onSelectAllChange(event: any, item: any) {
    this.selectAllOptions = event.checked;
    this.filteredOptions?.subscribe(options => {
      options.forEach(item => {
        if (this.selectAllOptions) {
          // check existed before adding
          if (!this.isOptionSelected(item)) {
            this.selectedOptions.add(item);
          }
        } else if (!this.selectAllOptions) {
          for (const option of this.selectedOptions) {
            if (option.category.id == item.id) {
              this.selectedOptions.delete(option);
              break;
            }
          }
        }
      });
    });
  }

  removeCondition(item: any) {
    for (const option of this.selectedOptions) {
      if (option.category.id == item.category.id) {
        this.selectedOptions.delete(option);
        break;
      }
    }
  }

  isItemExist(itemList: Set<any>, item): boolean {
    if (itemList.size > 0) {
      for (const elem of itemList) {
        if (elem.id == item.id) {
          return true;
        }
      }
    }

    return false;
  }
}
